/* eslint-disable no-unused-vars */
import Dropzone from 'react-dropzone';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import LoadingCircle from 'components/ui/LoadingCircle';
import { ACCEPTED_FILE_TYPES } from '../../../config/accepted-file-types';
import { DocumentsPreviewModal } from './DocumentsPreviewModal';
import { BILL_OF_LADING, PAYOUT, shipmentDocTypes, } from '../../../config/documents';
import { InvalidPDFs } from './InvalidPDFs';
import { useValidateDocuments } from '../../../utils/DocumentsHooks';
const BILL_OF_LADING_TYPES = [BILL_OF_LADING.value];
const PAYOUT_TYPES = [PAYOUT.value];
export function DocumentsUploader({ shipment, carrierDocumentUpload, onUpload, parentType, }) {
    const { t } = useTranslation();
    const [processing, setProcessing] = useState(false);
    const [showPreviewModal, setShowPreviewModal] = useState(false);
    const { validating, validFiles, invalidPDFs, handleValidate } = useValidateDocuments((validFiles, invalidPDFs) => {
        setShowPreviewModal(true);
    }, (files, e) => {
        setShowPreviewModal(false);
    });
    const handleUpload = (files, type, signatory) => {
        setProcessing(true);
        const uploadPromise = onUpload(files, type, signatory, true);
        uploadPromise.finally(() => {
            setProcessing(false);
        });
        return uploadPromise;
    };
    return (React.createElement("div", null,
        (validating || processing) && (React.createElement(LoadingCircle, { text: t('PROCESSING_FILES') })),
        React.createElement(InvalidPDFs, { invalidPDFs: invalidPDFs }),
        React.createElement(Dropzone, { style: {
                width: '100%',
                height: 100,
                padding: 10,
                borderWidth: 2,
                borderColor: '#337ab7',
                borderStyle: 'dashed',
                borderRadius: 5,
            }, onDrop: handleValidate, multiple: true, accept: ACCEPTED_FILE_TYPES },
            React.createElement("div", null, t('CLICK_OR_DRAG_TO_UPLOAD_FILE'))),
        React.createElement(DocumentsPreviewModal, { show: showPreviewModal, onHide: () => setShowPreviewModal(false), onUpload: handleUpload, files: validFiles, shipment: shipment, carrierDocumentUpload: carrierDocumentUpload, parentType: parentType })));
}
